<template>
  <div class="news wh100 pb50">
    <!-- <navBar title="动态" backgroundColor="transparent"></navBar> -->
    <div class="content">
      <van-tabs v-model="active" animated swipeable :before-change="beforeChange" @click="tabChange" @change="tabChange">
        <van-tab title="殡葬法规" name="0">
          <div class="list_content">
            <vantList :list="list" :loading="loading" :finished="finished" :refreshing="refreshing" @getList="getList()"
              @refresh="refresh">
              <div class="list" v-for="(item, index) in list" :key="index">
                <newsItem :item="item"></newsItem>
              </div>
            </vantList>
          </div>
        </van-tab>
        <van-tab title="殡葬文化" name="1">
          <div class="list_content">
            <vantList :list="list" :loading="loading" :finished="finished" :refreshing="refreshing" @getList="getList()"
              @refresh="refresh">
              <div class="list" v-for="(item, index) in list" :key="index">
                <newsItem :item="item"></newsItem>
              </div>
            </vantList>
          </div>
        </van-tab>
        <van-tab title="殡葬服务" name="2">
          <div class="list_content">
            <div class="popup_content">
              <div class="left" ref="left">
                <ul class="content">
                  <li v-for="(item, index) in left" :key="item.value" :class="{ current: currentIndex == index }"
                    @click="selectItem(index, $event)">
                    <span class="left-item">{{ item.label }}</span>
                  </li>
                </ul>
              </div>
              <vantList :list="list" :loading="loading" :finished="finished" :refreshing="refreshing" @getList="getList()"
                @refresh="refresh">
                <div class="right" ref="right">
                  <div v-for="(item, index) in list">
                    <li class="news_item" @click="goDetail(item.id)">
                      <div class="item_img">
                        <img v-if="item.url" :src="item.url" object-fit="cover" alt="" />
                        <img v-else :src="newsImg" alt="" />
                      </div>
                      <div class="item_info">
                        <div class="info_top">
                          <div class="info-title">{{ item.title }}</div>
                          <span class="info-title2">{{ item.title2 }}</span>
                          <span class="info-title3" @click.stop="callPhone(item.title3)">{{ item.title3 }}</span>
                        </div>
                      </div>
                    </li>
                  </div>
                </div>
              </vantList>
            </div>
          </div>
        </van-tab>
      </van-tabs>
    </div>
    <tabBar />
  </div>
</template>

<script>
import navBar from "@/components/navBar";
import tabBar from "@/components/tabBar";
import vantList from "@/components/list";
import newsItem from "./components/newsItem";

import { line_list } from "@/api/news/index";
export default {
  name: "news",
  data() {
    return {
      active: 0,
      list: [],
      loading: true,
      finished: false,
      refreshing: false,
      pageSize: 10,
      currentPage: 1,
      left: [
        {
          label: '殡仪馆',
          value: 1
        },
        {
          label: '公益性公墓',
          value: 2
        },
        {
          label: '经营性公墓',
          value: 3
        }
      ],
      right: [],
      currentIndex: 0,
      newsImg: require("../../assets/imgs/newsImg.png"),
      serverType: ''
    };
  },
  components: {
    navBar,
    tabBar,
    vantList,
    newsItem,
  },
  created() {
    let newsType = sessionStorage.getItem('newsType')
    if (newsType) {
      this.active = newsType
    } else {
      sessionStorage.setItem('newsType', 0)
    }
  },
  mounted() {
    this.getList();
  },
  methods: {
    //tab切换之前
    beforeChange() {
      if (this.loading) {
        return false;
      }
    },
    //tab切换
    tabChange(name, title) {
      console.log(name, title);
      sessionStorage.setItem('newsType', name)
      this.list = [];
      this.active = name;
      if (this.active == '2') {
        this.currentIndex = 0
      }
      this.currentPage = 1;
      this.finished = false;
      this.loading = true;
      this.refreshing = false;
      this.getList();
    },
    //请求数据
    async getList() {
      this.loading = true;
      const { currentPage, pageSize } = this;
      this.serverType = ''
      if (this.active == '2') {
        this.serverType = this.left[this.currentIndex].value
      } else {
        this.serverType = 0
      }
      let params = {
        currentPage,
        pageSize,
        newsType: this.active,
        serverType: this.serverType
      };
      let res = await line_list(params);
      this.loading = false;
      this.refreshing = false;
      console.log(res, '新闻');
      if (res.code === "2000") {
        let list = res.data || [];
        this.list = [...this.list, ...list];
        //根据总条数处理
        if (pageSize > list.length) {

          this.finished = true;
        } else {
          this.currentPage++
          this.finished = false;
        }
      }
    },
    //下拉刷新
    refresh() {
      this.refreshing = true;
      // 清空列表数据
      this.currentPage = 1;
      this.list = [];
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.getList();
    },
    //点击左侧分类
    selectItem(index) {
      this.currentIndex = index;
      this.serverType = this.left[index].value
      this.currentPage = 1;
      this.list = [];
      this.loading = true;
      this.getList();
    },
    goDetail(id) {
      this.$router.push(`/newsDetail/${id}`);
    },
    callPhone(phoneNumber) {
      console.log(phoneNumber);
      window.location.href = "tel://" + phoneNumber;
    },
  },
};
</script>

<style lang="scss" scoped>
.news {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -moz-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;

  .content {
    flex: 1;
    display: -webkit-box;
    display: -moz-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -moz-flex-direction: column;
    -webkit-flex-direction: column;
    flex-direction: column;
    overflow: hidden;

    /deep/ .van-tabs {
      flex: 1;
      display: -webkit-box;
      display: -moz-box;
      display: -ms-flexbox;
      display: -webkit-flex;
      display: flex;
      -moz-flex-direction: column;
      -webkit-flex-direction: column;
      flex-direction: column;
      overflow-y: scroll;

      .van-tabs__content {
        flex: 1;

        .van-tab__pane {
          height: 100%;
        }
      }
    }
  }

  /deep/ .van-nav-bar__title {
    color: $textColor !important;
  }

  /deep/ .van-tabs--line .van-tabs__wrap {
    padding-top: 0.05rem;

    .van-tabs__nav {
      justify-content: space-around;

      .van-tabs__line {
        display: none;
      }

      .van-tab {
        width: 1rem;
        height: 0.3rem;
        background: #efefef;
        color: $lightBlack;
        flex: none;
        border-radius: 0.05rem;
      }

      .van-tab--active {
        background: $defaultColor;
        color: #fff;
      }
    }
  }

  .list_content {
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    background: #f9f9f9;
    height: 100%;
    padding: 0 0.1rem;
    width: 100%;

    /deep/ .van-list {
      width: 100%;

      .list_item {
        width: 100%;
        height: 0.8rem;
      }
    }
  }

  .popup_content {
    // flex: 1;
    // margin-bottom: 0.12rem;
    display: -webkit-box;
    display: -moz-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -moz-justify-content: space-between;
    -webkit-justify-content: space-between;
    justify-content: space-between;
    overflow: hidden;
    margin-top: 0.12rem;
    height: calc(100% - 28px);

    /deep/ .van-pull-refresh {
      width: calc(100% - 1rem) !important;
    }

    .news_item {
      width: 100%;
      padding: 0.1rem 0.1rem;
      display: -webkit-box;
      display: -moz-box;
      display: -ms-flexbox;
      display: -webkit-flex;
      display: flex;
      margin: 0.05rem 0;
      // height: 6rem;
      background: #fff;

      .item_img {
        width: 0.8rem;
        height: 0.8rem;
        margin-right: 0.07rem;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .item_info {
        flex: 1;
        width: calc(100% - 0.87rem);
        .info_top {
          margin-bottom: 0.05rem;
          display: flex;
          flex-direction: column;

          .info-title {
            font-size: 0.16rem;
            font-weight: 600;
            color: #333333;
            overflow-x: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            line-height: initial;
          }

          .info-title2 {
            color: #666666;
            font-size: 0.13rem;
            margin-top: 0.08rem;
          }

          .info-title3 {
            color: #003edc;
            font-size: 0.13rem;
            margin-top: 0.08rem;
          }
        }

        p {
          width: 2.17rem;
          height: 0.44rem;
          font-size: 12px;
          line-height: 0.15rem;
          color: $lightBlack;
        }
      }
    }

    .left {
      flex: 0 0 1rem;
      background-color: #fff;
      margin-right: 0.1rem;
      width: 1.3rem;
      height: 100%;

      li {
        display: -webkit-box;
        display: -moz-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -moz-align-items: center;
        -webkit-align-items: center;
        align-items: center;
        -moz-justify-content: center;
        -webkit-justify-content: center;
        justify-content: center;
        width: 100%;
        height: 0.5rem;
        position: relative;
      }

      .current {
        background: #f1f1f1;
        color: $defaultColor;
      }

      .current::after {
        content: "";
        width: 4px;
        height: 15px;
        border-radius: 5px 0 0 5px;
        position: absolute;
        background-color: $defaultColor;
        top: 0;
        right: 0px;
        bottom: 0;
        margin: auto;
      }
    }

    .right {
      flex: 1;

      .right-item {
        margin-top: 0.1rem;
        background-color: #fff;

        h2 {
          display: -webkit-box;
          display: -moz-box;
          display: -ms-flexbox;
          display: -webkit-flex;
          display: flex;
          -moz-align-items: center;
          -webkit-align-items: center;
          align-items: center;
          padding-left: 0.15rem;
          height: 0.5rem;
          border-bottom: 1px solid rgba(0, 0, 0, 0.1);

          span {
            margin-left: 0.05rem;
          }
        }

        h2::before {
          content: "";
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background: $defaultColor;
        }

        li {
          width: 100%;
          padding: 0.15rem 0.1rem 0.15rem 0.15rem;
          display: -webkit-box;
          display: -moz-box;
          display: -ms-flexbox;
          display: -webkit-flex;
          display: flex;
          -moz-align-items: center;
          -webkit-align-items: center;
          align-items: center;
          border-bottom: 1px solid rgba(0, 0, 0, 0.1);

          .img_box {
            width: 0.6rem;
            height: 0.6rem;
            background: #efefef;
            border-radius: 0.03rem;
            padding: 0.1rem;
            margin-right: 0.08rem;

            img {
              width: 100%;
              height: 100%;
            }
          }

          .child_info {
            flex: 1;
            display: -webkit-box;
            display: -moz-box;
            display: -ms-flexbox;
            display: -webkit-flex;
            display: flex;
            -moz-align-items: center;
            -webkit-align-items: center;
            align-items: center;
            -moz-justify-content: space-between;
            -webkit-justify-content: space-between;
            justify-content: space-between;

            .info_left {
              h3 {
                font-size: 14px;
                line-height: 0.2rem;
                margin-bottom: 0.05rem;
              }

              h4 {
                display: -webkit-box;
                display: -moz-box;
                display: -ms-flexbox;
                display: -webkit-flex;
                display: flex;
                -moz-align-items: center;
                -webkit-align-items: center;
                align-items: center;
                font-size: 12px;
                color: $lightBlack;

                span {
                  color: $defaultColor;
                }
              }
            }

            .info_right {
              width: 0.72rem;
              height: 0.3rem;
              color: #fff;
              display: -webkit-box;
              display: -moz-box;
              display: -ms-flexbox;
              display: -webkit-flex;
              display: flex;
              -moz-align-items: center;
              -webkit-align-items: center;
              align-items: center;
              -moz-justify-content: center;
              -webkit-justify-content: center;
              justify-content: center;
              background: $defaultColor;
              border-radius: 0.06rem;
            }
          }
        }
      }
    }
  }
}</style>
